import { MaskedLine } from "./Reveal";

const PageHero = ({ eyebrow, titleLines, lede, testId }) => (
  <section
    data-testid={testId}
    className="relative bg-offwhite border-b border-line pt-40 pb-16 sm:pt-48 sm:pb-24 overflow-hidden"
  >
    <div
      className="absolute inset-0 opacity-[0.5]"
      style={{
        backgroundImage:
          "linear-gradient(to right, rgba(184,154,99,0.05) 1px, transparent 1px)",
        backgroundSize: "clamp(80px, 12vw, 160px) 100%",
      }}
      aria-hidden="true"
    />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <p className="eyebrow mb-6" data-testid={`${testId}-eyebrow`}>
        {eyebrow}
      </p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-charcoal leading-[1.08]">
        {titleLines.map((line, i) => (
          <MaskedLine key={line} delay={0.12 * i + 0.15}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {lede && (
        <p className="mt-7 max-w-2xl text-base sm:text-lg text-charcoal-mute leading-relaxed">
          {lede}
        </p>
      )}
    </div>
  </section>
);

export default PageHero;
